import React, { useState } from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import logoGF from '../../images/logo_GF.svg';
import { PerfilUsuarioEnum } from '../../enums';
import { CardErro, Body } from '../../presentations';
import AutoCompleteEmpresa from '../AutoCompleteEmpresa';
import ListagemCardEmpresa from '../ListagemCardEmpresa';

const useStyles = makeStyles(theme => ({
    root: {
        padding: 20
    },
    gridHeader: {
        height: 70,
        backgroundColor: theme.palette.primary.main
    },
    gridBody: {
        marginTop: 30
    }
}));

function SelecaoEmpresaPage() {
    const classes = useStyles();
    const [error, setError] = useState(null);
    const { role } = JSON.parse(localStorage.getItem('user_data'));

    const handleError = (value) => {
        setError(value);
    }

    return (
        <>
            <Grid container
                direction="column"
                alignItems="center"
                justify="center"
                className={classes.gridHeader}>
                <Grid item>
                    <img alt='' src={logoGF} />
                </Grid>
            </Grid>
            {
                (() => {
                    if (error !== null)
                        return <CardErro />

                    return (
                        <Grid container
                            direction="column"
                            alignItems="center"
                            justify="center"
                            className={classes.gridBody}>
                            <Grid item>
                                <Typography color='primary' variant='h5'>
                                    Escolha a empresa
                                </Typography>
                            </Grid>
                            {
                                role === PerfilUsuarioEnum.GESTOR ?
                                    <ListagemCardEmpresa handleError={handleError} /> :
                                    <AutoCompleteEmpresa handleError={handleError} />
                            }
                        </Grid>
                    )
                })()
            }
        </>
    );
}

export default SelecaoEmpresaPage;